/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Mapping } from '../../models/mapping';
import { MappingResponse } from '../../models/mapping-response';

export interface MappingPut$Params {
  'Active-Tenant-Identifier': string;
      body: Mapping
}

export function mappingPut(http: HttpClient, rootUrl: string, params: MappingPut$Params, context?: HttpContext): Observable<StrictHttpResponse<MappingResponse>> {
  const rb = new RequestBuilder(rootUrl, mappingPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MappingResponse>;
    })
  );
}

mappingPut.PATH = '/om/mappings';
